// Generated using yarn generate command
import { css } from '@emotion/react';
import { themed } from '../utils/styling/themed';
import { margins, flex, unit } from '../utils/styling/utilityClasses';
import { paddings, spacings } from '../utils/styling/utilityTokens';

export const inline_notification_base = themed(
  ({ palette, typography }) => css`
    border: 1px solid;
    border-radius: ${palette.border.radiusRegular};
    ${paddings.y.tight}
    ${paddings.x.comfortable}

    position: relative;

    .BlocksAlert-left-border {
      position: absolute;
      bottom: 0px;
      left: 0px;
      top: 0px;
      right: 0px;
      border-radius: ${palette.border.radiusRegular};
      border-left: 4px solid;
      clip-path: polygon(0 0, 4px 0, 4px 100%, 0% 100%);
    }

    .BlocksInlineNotification-actionContainer {
      ${flex.init}
      ${flex.align.center}
      width: max-content;
      ${spacings.small}
      height: 100%;
    }

    .MuiAlertTitle-root {
      margin-bottom: 4px;
      ${typography.body2.default}
      ${typography.body2.semibold}
      /** Override Mui's default margin-top: -2px **/
      ${margins.yt.m0}
    }

    .MuiButton-contained {
      background-color: ${palette.surface.background};
      color: ${palette.text.brand};
    }

    .BlocksIconButton-root {
      background-color: transparent;
    }

    .MuiAlert-message {
      ${paddings.x.none}
      ${paddings.y.none}
    }

    .MuiAlert-icon {
      ${paddings.x.none}
      ${paddings.y.none}     
      ${margins.xr.half}      
 
      font-size: ${unit(1.25)};
      height: ${unit(1.25)};
      display: inline-block;
    }
    .MuiAlert-action {
      ${paddings.yt.none}
      margin-right: 0px;
    }
  `,
);

export const warning_inline_notification = themed(
  ({ palette }) => css`
    background-color: ${palette.bg.warningSubtle};
    border-color: ${palette.border.warningSubtle};

    .MuiAlert-icon {
      color: ${palette.icon.warning};
    }

    .MuiAlertTitle-root {
      color: ${palette.text.warning};
    }

    .BlocksAlert-left-border {
      border-color: ${palette.border.warning};
    }
  `,
);

export const error_inline_notification = themed(
  ({ palette }) => css`
    background-color: ${palette.bg.errorSubtle};
    border-color: ${palette.border.errorSubtle};

    .MuiAlert-icon {
      color: ${palette.icon.error};
    }

    .MuiAlertTitle-root {
      color: ${palette.text.error};
    }

    .BlocksAlert-left-border {
      border-color: ${palette.border.error};
    }
  `,
);

export const success_inline_notification = themed(
  ({ palette }) => css`
    background-color: ${palette.bg.successSubtle};
    border-color: ${palette.border.successSubtle};

    .MuiAlert-icon {
      color: ${palette.icon.success};
    }

    .MuiAlertTitle-root {
      color: ${palette.text.success};
    }

    .BlocksAlert-left-border {
      border-color: ${palette.border.success};
    }
  `,
);

export const info_inline_notification = themed(
  ({ palette }) => css`
    background-color: ${palette.bg.infoSubtle};
    border-color: ${palette.border.infoSubtle};

    .MuiAlert-icon {
      color: ${palette.icon.infoLink};
    }

    .MuiAlertTitle-root {
      color: ${palette.text.link};
    }

    .BlocksAlert-left-border {
      border-color: ${palette.border.info};
    }
  `,
);

export const white_inline_notification = themed(
  ({ palette }) => css`
    background-color: ${palette.surface.base};
    border-color: ${palette.border.light};

    .MuiAlert-icon {
      color: ${palette.icon.primary};
    }

    .MuiAlertTitle-root {
      color: ${palette.text.secondary};
    }

    .BlocksAlert-left-border {
      border-color: ${palette.border.active};
    }
  `,
);

export const subtle_inline_notification = themed(
  ({ palette }) => css`
    background-color: ${palette.surface.background};
    border-color: ${palette.border.light};

    .MuiAlert-icon {
      color: ${palette.icon.primary};
    }

    .MuiAlertTitle-root {
      color: ${palette.text.secondary};
    }

    .BlocksAlert-left-border {
      border-color: ${palette.border.active};
    }
  `,
);
